import React from 'react';
import Card from '../ui/Card';
import EmptyState from '../ui/EmptyState';
import './EmployeeWorkspace.css';

export function EmployeeWorkspaceLayout({ navigation, children }) {
  return (
    <div className="employee-workspace">
      <div className="employee-workspace__navigation">{navigation}</div>
      <div className="employee-workspace__content">{children}</div>
    </div>
  );
}

export function EmployeeWorkspaceSection({ title, description, actions = null, children, className = '' }) {
  return (
    <Card className={`employee-workspace-section ${className}`.trim()} padding="md" shadow="sm">
      <header className="employee-workspace-section__header">
        <div>
          <h2>{title}</h2>
          {description ? <p>{description}</p> : null}
        </div>
        {actions ? <div className="employee-workspace-section__actions">{actions}</div> : null}
      </header>
      <div className="employee-workspace-section__body">{children}</div>
    </Card>
  );
}

export function EmployeeSummaryCard({ label, value = '—', detail = null, tone = 'neutral' }) {
  return (
    <Card className={`employee-summary-card employee-summary-card--${tone}`} padding="md" shadow="sm">
      <div className="employee-summary-card__label">{label}</div>
      <div className="employee-summary-card__value">{value}</div>
      {detail ? <div className="employee-summary-card__detail">{detail}</div> : null}
    </Card>
  );
}

export function EmployeeDashboardGrid({ children, columns = 'standard', className = '' }) {
  return (
    <div className={`employee-dashboard-grid employee-dashboard-grid--${columns} ${className}`.trim()}>
      {children}
    </div>
  );
}

export function EmployeeDetailList({ items }) {
  return (
    <dl className="employee-detail-list">
      {items.map(({ label, value }) => (
        <React.Fragment key={label}>
          <dt>{label}</dt>
          <dd className={value === null || value === undefined || value === '' ? 'is-empty' : ''}>
            {value === null || value === undefined || value === '' ? '—' : value}
          </dd>
        </React.Fragment>
      ))}
    </dl>
  );
}

export function EmployeeWorkspaceEmptyState({ title, description, release = 'Future release' }) {
  const releaseCopy = release ? ` ${release}.` : '';
  return (
    <EmptyState
      icon="·"
      headline={title}
      body={`${description}${releaseCopy} No employee data is available for this capability yet.`}
      className="employee-workspace-empty"
    />
  );
}

export function PlannedWorkspaceSection({ title, description }) {
  return (
    <EmployeeWorkspaceSection title={title} description="Planned capability">
      <EmployeeWorkspaceEmptyState title={`${title} is planned`} description={description} />
    </EmployeeWorkspaceSection>
  );
}

export function EmployeeAiPreparation() {
  const capabilities = [
    ['AI Summary', 'A governed summary of authorized workforce context.'],
    ['Strengths', 'Evidence-linked strengths from approved performance sources.'],
    ['Concerns', 'Reviewable concerns with source context and human oversight.'],
    ['Recommendations', 'Suggested next steps that remain manager decisions.'],
    ['Promotion Readiness', 'A transparent, reviewable readiness assessment.'],
    ['Recent Coaching', 'Authorized coaching context summarized for follow-up.']
  ];

  return (
    <EmployeeWorkspaceSection
      title="AI Insights"
      description="Reserved architecture for future governed assistance. No AI processing is active."
    >
      <div className="employee-ai-grid">
        {capabilities.map(([title, description]) => (
          <div className="employee-ai-grid__item" key={title}>
            <span className="employee-ai-grid__status">Future release</span>
            <h3>{title}</h3>
            <p>{description}</p>
          </div>
        ))}
      </div>
    </EmployeeWorkspaceSection>
  );
}
